export const TABLE_HEAD_VARIANTS = {
  white_head: "white_head",
  blue_head: "blue_head",
} as const;

export type TableHeadVariantsType = keyof typeof TABLE_HEAD_VARIANTS;
